var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadPdf = function SvgDownloadPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.6,
    height: 26,
    viewBox: "0 0 22.06 23",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "pdf download")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.47,23H3.64A3.64,3.64,0,0,1,0,19.36V4.63A3.64,3.64,0,0,1,3.64,1H10a.35.35,0,0,1,0,.7H3.64A2.94,2.94,0,0,0,.7,4.63V19.36A2.94,2.94,0,0,0,3.64,22.3H15.47a2.94,2.94,0,0,0,2.94-2.94V14.15a.35.35,0,1,1,.7,0v5.21A3.65,3.65,0,0,1,15.47,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35,11.43a5.72,5.72,0,1,1,5.71-5.72A5.73,5.73,0,0,1,16.35,11.43ZM16.35.7a5,5,0,1,0,5,5A5,5,0,0,0,16.35.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35,9.42,13.6,6.94a.27.27,0,1,1,.37-.4l2.38,2.15,2.37-2.15a.27.27,0,1,1,.37.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35,8.89a.28.28,0,0,1-.28-.27V2.37a.28.28,0,0,1,.28-.27.27.27,0,0,1,.27.27V8.62A.27.27,0,0,1,16.35,8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61,20.25a.3.3,0,0,1-.3-.31v-3a.29.29,0,0,1,.3-.3h.91a1.21,1.21,0,0,1,0,2.42H5.91v.91a.3.3,0,0,1-.3.31Zm.3-1.82h.61a.61.61,0,1,0,0-1.22H5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86,20.25H8.64a.31.31,0,0,1-.3-.31v-3a.3.3,0,0,1,.3-.3H9.86a.91.91,0,0,1,.91.91v1.82a.91.91,0,0,1-.91.91ZM9,19.64h.91a.3.3,0,0,0,.3-.3V17.52a.31.31,0,0,0-.3-.31H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68,20.25a.31.31,0,0,1-.31-.31V17.52a.91.91,0,0,1,.92-.91H13.5a.3.3,0,0,1,0,.6H12.29a.31.31,0,0,0-.31.31v2.42a.3.3,0,0,1-.3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,19H11.68a.3.3,0,1,1,0-.6H13.5a.3.3,0,0,1,0,.6Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadPdf.54addcae.svg";
export { ForwardRef as ReactComponent };